import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./table-collection.json";
import data from "./table-data.json";

export const TableThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
